module.exports = __webpack_public_path__ + "static/img/1.1213446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/1.png
// module id = hc34
// module chunks = 0